import React from "react";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

export default function SkeletonWrapper({ loading: waiting, children }) {
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        setLoading(waiting);
    }, [waiting]);

    return loading ? <Skeleton style={{ minHeight: "290px" }} /> : <>{children}</>
}
